import calculateImageProxyPath from './calculateImageProxyPath';

/**
 * Load an image from model B proxy -- connector proxy
 * @param img The image
 */
export default async function loadFromModelBProxy(img: HTMLImageElement): Promise<boolean> {
    const imageProxyPath = await calculateImageProxyPath(img);
    if (imageProxyPath) {
        img.src = imageProxyPath;
        return true;
    }

    return false;
}
